import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InfoPackageComponent } from './info-package.component';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { RouterModule } from '@angular/router';
import { DaLinkModule } from '../da-link';
import { DaProgressiveImageModule } from '../da-progressive-image';
import { DaButtonModule } from '../da-button';

@NgModule({
    declarations: [InfoPackageComponent],
    imports: [CommonModule, TranslateModule, RouterModule, LocalizeRouterModule, DaButtonModule, DaLinkModule, DaProgressiveImageModule],
    providers: [],
    exports: [InfoPackageComponent]
})
export class InfoPackageModule {
    constructor() {}

    ngInit() {}
}
